'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'tab-focusable',

  data: function data() {
    return {
      tabFocused: false
    };
  }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/vuetify/es5/mixins/tab-focusable.js
// module id = 286
// module chunks = 5